import { Axios } from "index";

export const faceItemSrnoDropdownApi = "/face-inventory/item-srno-dropdown";
export const faceInwardSrnoDropdownApi = "/face-inventory/inward-srno-dropdown";

//Approval
export const fetchFaceApprovalApi = `/approval/face-approval-invoice-listing`;
export const fetchFaceItemsApprovalApi = function (id, invoice_id) {
  return `/approval/face-approval-item-listing-by-invoice/${id}/${invoice_id}`;
};
export const faceApproveInvoiceApi = function (id, invoice_id) {
  return `/approval/face-approve_invoice_details/${id}/${invoice_id}`;
};
export const faceRejectInvoiceApi = function (id, invoice_id) {
  return `/approval/face-reject_invoice_details/${id}/${invoice_id}`;
};

export const fetchFaceInwardNo = async (id) => {
  const res = await Axios.get(`/face-inventory/inward-sr-no-dropdown/${id}`);
  return res;
};
export const fetchFaceNoDropdown = async (id, itemId) => {
  const res = await Axios.get(
    `/face-inventory/item-sr-no-dropdown/${id}/${itemId}`
  );
  return res;
};
export const fetchFaceNoById = async (id) => {
  const res = await Axios.get(`/face-inventory/list-face-details/${id}`);
  return res;
};

export const addRawOrderFace = async (data) => {
  const res = await Axios.post("/order/issue-raw-face-order/issue-order", data);
  return res;
};
export const revertRawOrderFace = async (id) => {
  const res = await Axios.post(`/order/revert-order/${id}`);
  return res;
};
